import type { ResumeData } from "./index";

export const sampleResume: ResumeData = {
  basics: {
    name: "Your Name",
    headline: "Your Job Title",
    email: "email.address@xyzx.com",
    phone: "(555) 123-4567",
    location: "Your City, Country",
    url: {
      label: "",
      href: "https://ai.stylion.io/",
    },
    customFields: [],
    picture: {
      url: "/images/default-profile.jpg",
      size: 120,
      aspectRatio: 1,
      borderRadius: 0,
      effects: {
        hidden: false,
        border: false,
        grayscale: false,
      },
    },
  },
  sections: {
    summary: {
      name: "Summary",
      icon: "article",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "summary",
      content: "<p>Write a brief summary about yourself, your experience, and your career goals. Highlight your <strong>key skills</strong> and what makes you stand out as a professional.</p>",
    },
    awards: {
      name: "Awards",
      icon: "trophy",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "awards",
      items: [],
    },
    certifications: {
      name: "Certifications",
      icon: "certificate",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "certifications",
      items: [
        {
          id: "spdhh9rrqi1gvj0yqnbqunlo",
          visible: true,
          name: "Certification Name",
          issuer: "Issuing Organization",
          date: "01/01/2026",
          summary: "",
          url: {
            label: "",
            href: "",
          },
        },
        {
          id: "n838rddyqv47zexn6cxauwqp",
          visible: true,
          name: "Certification Name",
          issuer: "Issuing Organization",
          date: "01/01/2026",
          summary: "",
          url: {
            label: "",
            href: "",
          },
        },
      ],
    },
    education: {
      name: "Education",
      icon: "graduation-cap",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "education",
      items: [
        {
          id: "yo3p200zo45c6cdqc6a2vtt3",
          visible: true,
          institution: "University Name",
          studyType: "Degree Title",
          area: "City, Country",
          score: "",
          date: "01/01/2020 to 01/01/2024",
          summary: "",
          url: {
            label: "",
            href: "",
          },
        },
      ],
    },
    experience: {
      name: "Experience",
      icon: "briefcase",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "experience",
      items: [
        {
          id: "lhw25d7gf32wgdfpsktf6e0x",
          visible: true,
          company: "Company Name",
          position: "Job Title Here",
          location: "City, Country",
          date: "01/01/2022 to Present",
          summary:
            "<ul><li><p>Describe your key responsibility or achievement in this role.</p></li><li><p>Mention a specific project or result you contributed to.</p></li><li><p>Highlight any leadership, teamwork, or technical skills you applied.</p></li></ul>",
          url: {
            label: "",
            href: "",
          },
        },
        {
          id: "r6543lil53ntrxmvel53gbtm",
          visible: true,
          company: "Company Name",
          position: "Job Title Here",
          location: "City, Country",
          date: "01/01/2020 to 01/01/2022",
          summary:
            "<ul><li><p>Describe your key responsibility or achievement in this role.</p></li><li><p>Mention a specific project or result you contributed to.</p></li><li><p>Highlight any leadership, teamwork, or technical skills you applied.</p></li></ul>",
          url: {
            label: "",
            href: "",
          },
        },
      ],
    },
    volunteer: {
      name: "Volunteering",
      icon: "hand-heart",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "volunteer",
      items: [],
    },
    interests: {
      name: "Interests",
      icon: "sparkle",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "interests",
      items: [
        {
          id: "drrsjcq3k9di6uyrt9ajiizg",
          name: "Technology Innovation",
          visible: true,
          keywords: ["Artificial Intelligence", "Machine Learning", "Blockchain"],
        },
        {
          id: "kmpq8uh5n7jw2vx4r9tbegsc",
          name: "Professional Development",
          visible: true,
          keywords: ["Leadership", "Mentoring", "Industry Networking"],
        },
      ],
    },
    languages: {
      name: "Languages",
      icon: "translate",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "languages",
      items: [
        {
          id: "k9seu433tkumjseux8pklxtu",
          name: "English",
          level: 5,
          visible: true,
          description: "Native",
        },
        {
          id: "t2hy8q5m1wati1dyydlh508t",
          name: "French",
          level: 4,
          visible: true,
          description: "Fluent",
        },
      ],
    },
    profiles: {
      name: "Profiles",
      icon: "identification-badge",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "profiles",
      items: [
        {
          id: "cnbk5f0aeqvhx69ebk7hktwd",
          visible: true,
          network: "LinkedIn",
          username: "johndoe",
          icon: "linkedin",
          url: {
            label: "",
            href: "https://linkedin.com/in/johndoe",
          },
        },
        {
          id: "ukl0uecvzkgm27mlye0wazlb",
          visible: true,
          network: "GitHub",
          username: "johndoe",
          icon: "github",
          url: {
            label: "",
            href: "https://github.com/johndoe",
          },
        },
      ],
    },
    projects: {
      name: "Projects",
      icon: "folder-open",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "projects",
      items: [
        {
          id: "yw843emozcth8s1ubi1ubvlf",
          visible: true,
          name: "Project Name",
          description: "Your Role",
          date: "",
          summary:
            "<p>Describe the project briefly and highlight your key contributions and results.</p>",
          keywords: [],
          url: {
            label: "",
            href: "",
          },
        },
        {
          id: "ncxgdjjky54gh59iz2t1xi1v",
          visible: true,
          name: "Project Name",
          description: "Your Role",
          date: "",
          summary:
            "<p>Describe the project briefly and highlight your key contributions and results.</p>",
          keywords: [],
          url: {
            label: "",
            href: "",
          },
        },
      ],
    },
    publications: {
      name: "Publications",
      icon: "book-open",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "publications",
      items: [],
    },
    hobbies: {
      name: "Hobbies",
      icon: "palette",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "hobbies",
      items: [
        {
          id: "e9n8bleatgf414w2jvl0bu2g",
          icon: "Basket-Ball",
          name: "Basketball",
          visible: true,
          description: "",
        },
        {
          id: "ny3bg54lrucoj7bzpgsmp0tp",
          icon: "News-paper",
          name: "Reading",
          visible: true,
          description: "",
        },
      ],
    },
    mostProudOf: {
      name: "Core Strengths",
      icon: "medal",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "mostProudOf",
      items: [
        { id: "q7m4vny2u3h9k8t5r1c6d0bz", visible: true, name: "Delivered High-Impact Projects", description: "Successfully led and delivered key projects on time, exceeding stakeholder expectations and driving measurable results.", icon: "trophy" },
        { id: "w2k9d1p6x8r3t5m7n4c0v2qy", visible: true, name: "Built Strong Teams", description: "Fostered collaborative team environments that boosted productivity, morale, and professional growth across departments.", icon: "user-tie" },
        { id: "h6t3n9q1v4m8k2r5x7c0d1pz", visible: true, name: "Continuous Professional Growth", description: "Committed to lifelong learning by earning certifications, attending workshops, and staying current with industry trends.", icon: "star-full" },
      ],
    },
    myMind: {
      name: "Mindset & Strengths",
      icon: "brain",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "myMind",
      items: [
        { id: "m8c2v7k1r4t9n3q6d0x5p2wy", visible: true, label: "Leadership", description: "Guiding teams toward shared goals with confidence", percentage: 25, color: "" },
        { id: "p4r8n2t6v1k9m3c7x0d5q2hz", visible: true, label: "Problem Solving", description: "Analyzing challenges and delivering effective results", percentage: 25, color: "" },
        { id: "x3k7m1v5t9r2n6c4d0p8q2wy", visible: true, label: "Collaboration", description: "Working effectively with diverse teams to achieve success", percentage: 20, color: "" },
        { id: "t5n9r3k7v1m4c8x2d0q6p2hz", visible: true, label: "Creativity", description: "Generating innovative ideas and unique solutions", percentage: 30, color: "" },
      ],
      ringThickness: 4,
      showLegend: true,
      legendPlacement: "right" as const,
    },
    references: {
      name: "References",
      icon: "users",
      columns: 1,
      separateLinks: true,
      visible: false,
      id: "references",
      items: [
        {
          id: "f2sv5z0cce6ztjl87yuk8fak",
          visible: true,
          name: "Available upon request",
          description: "",
          summary: "",
          url: {
            label: "",
            href: "",
          },
        },
      ],
    },
    signature: {
      id: "signature",
      name: "Signature",
      icon: "pen-nib",
      items: [
        {
          id: "j8oy5rbcf4zc1f88pj54umq8",
          content: "Your Name",
          visible: true,
        },
      ],
      columns: 1,
      visible: true,
      separateLinks: true,
    },
    skills: {
      name: "Skills",
      icon: "lightning",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "skills",
      items: [
        {
          id: "hn0keriukh6c0ojktl9gsgjm",
          visible: true,
          name: "Skill Category",
          description: "Advanced",
          level: 4,
          keywords: ["Skill 1", "Skill 2", "Skill 3", "Skill 4"],
        },
        {
          id: "r8c3y47vykausqrgmzwg5pur",
          visible: true,
          name: "Skill Category",
          description: "Intermediate",
          level: 4,
          keywords: ["Skill 1", "Skill 2", "Skill 3", "Skill 4"],
        },
        {
          id: "b5l75aseexqv17quvqgh73fe",
          visible: true,
          name: "Skill Category",
          description: "Intermediate",
          level: 4,
          keywords: ["Skill 1", "Skill 2", "Skill 3", "Skill 4"],
        },
      ],
    },
    custom: {},
  },
  metadata: {
    schemaVersion: "1.0.0",
    template: "vibrant",
    layout: [
      [
        ["summary", "experience", "education", "projects", "references", "mostProudOf", "myMind"],
        [
          "profiles",
          "skills",
          "certifications",
          "interests",
          "hobbies",
          "languages",
          "awards",
          "volunteer",
          "publications",
        ],
      ],
    ],
    css: {
      value: "",
      visible: false,
    },
    page: {
      margin: 40,
      format: "a4",
      options: {
        breakLine: false,
        pageNumbers: true,
      },
    },
    theme: {
      background: "#ffffff",
      text: "#000000",
      primary: "#1b79db",
    },
    typography: {
      font: {
        family: "Merriweather",
        subset: "latin",
        variants: ["regular"],
        size: 13,
      },
      lineHeight: 1.75,
      hideIcons: true,
      underlineLinks: true,
      headerFontSize: 22,
      headerTransform: "uppercase",
    },
    notes: "",
    // Selected background image (bg7 as default)
    backgroundImage: "7",
    // No signature by default
    signature: "",
    locale: "en-US",
  },
};
